// Import our CSS
import "../css/style.css";

import { Alpine } from "alpinejs";
import collapse from "@alpinejs/collapse";
import { GLightbox } from "./@types/shims";
import MobileMenu from "./MobileMenu/MobileMenu";
import SaveProduct from "./SaveProduct/SaveProduct";

export type ComponentConfig = {
	promise: Promise<object>;
	callback?: CallableFunction;
};

const init = async () => {
	MobileMenu();
	SaveProduct();

	const promises: ComponentConfig[] = [];

	if (document.querySelector("[x-data]")) {
		promises.push({
			promise: import("alpinejs"),
			callback: (Alpine: Alpine) => {
				Alpine.plugin(collapse);
				window.Alpine = Alpine;
				Alpine.start();
			},
		});
	}

	if (document.getElementById("mobile-menu-nav")) {
		promises.push({
			promise: import("./MobileMenu/MobileMenu"),
		});
	}

	if (document.getElementById("slider-finish-options-section")) {
		promises.push({
			promise: import("./FinishOptions/FinishOptions"),
		});
	}

	if (document.getElementById("slider-product-overview")) {
		promises.push({
			promise: import("./SliderProductOverview/SliderProductOverview"),
		});
	}

	if (document.querySelector("[data-jump-nav-links]")) {
		promises.push({
			promise: import("./StickyNav/StickyNav"),
		});
	}

	if (document.querySelector(".glightbox,[data-glightbox]")) {
		promises.push({
			promise: import("./Lightbox/Lightbox"),
			callback: (GLightbox: GLightbox) => {
				window.GLightbox = GLightbox;
			},
		});
	}

    for (const config of promises) {
        (config: ComponentConfig) => {
            config.promise.then((c) => {
                const result = c.default;
                if (typeof c.default === "function") {
                    console.log("Calling c.default()", c);
                    c.default();
                }
                if (config.callback) {
                    console.debug("Invoking callback");
                    config.callback(result);
                }
            });
        }
    }

	return Promise.all(promises.map((p) => p.promise));
};

init().then(() => {
	console.log("Done main.ts");
});